module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/sdk-fail.4d5dd8d4.png";